<template>
  <v-dialog v-model="modalStatus" scrollable persistent>
    <v-card>
      <v-card-text>
        <iframe :src="path" width="100%" style="height: 70vh"></iframe>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" dark @click="closeModal">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["openModal", "url"],
  data() {
    return {
      modalStatus: this.openModal,
      path: this.url,
    };
  },
  methods: {
    closeModal() {
      this.path = null;
      this.modalStatus = false;
      this.$emit("close-modal");
    },
  },
};
</script>